import script from "./WorldsScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorldsScreen.vue?vue&type=script&setup=true&lang=ts"

import "./WorldsScreen.vue?vue&type=style&index=0&id=01986d72&lang=scss"

const __exports__ = script;

export default __exports__